module.exports = __webpack_public_path__ + "static/media/idvisuelle.79fd1df0.png";